import React from "react";
import "./Contact.css";
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id="contact">
      <div className="container-fluid px-md-5 my-5 py-5 px-3">
        <div className="text-center">
          <h6 className="section-title">{t('contact.title')}</h6>
          <h4 className="section-suptitle">
            {t('contact.form_subtitle')}
          </h4>
          <p className="section-desc w-66 mx-auto mb-3">
            {t('contact.form_desc')}
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form className="partner-form mx-auto">
              <select className="form-control py-2 mb-3">
                <option selected disabled>{t('contact.partner_or_client')}</option>
                <option>{t('contact.partner')}</option>
                <option>{t('contact.client')}</option>
              </select>

              <input
                type="text"
                className="form-control py-2 mb-3"
                placeholder={t('contact.name')}
              />

              <input
                type="email"
                className="form-control py-2 mb-3"
                placeholder={t('contact.email')}
              />

              <input
                type="text"
                className="form-control py-2 mb-3"
                placeholder={t('contact.phone')}
              />

              <textarea
                rows="4"
                className="form-control py-2 mb-4"
                placeholder={t('contact.question')}></textarea>

              <button type="submit" className="contact-btn w-100 send-btn px-4 rounded-1 py-2 ">
                {t('contact.send')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
